import React from "react";
import CommunityViewPage from "../community/components/CommunityViewPage";
import { OTHER_REQUESTS } from "../community/constants";

export default function ViewOtherRequestsPage() {
  return <CommunityViewPage section={OTHER_REQUESTS} />;
}
